
import AdvancedTabsComponent from "./AdvancedTabs/AdvancedTabs";

export const AdvancedTabs = AdvancedTabsComponent;
